import apiCompleteVideo from '../../utils/video/videoApi';

import { WIDGET_ENGAGED } from '../Widget/actions';

export const VIDEO_INITIATED = 'VIDEO_INITIATED';
export const VIDEO_PLAY = 'VIDEO_PLAY';
export const VIDEO_PAUSED = 'VIDEO_PAUSED';
export const VIDEO_COMPLETED = 'VIDEO_COMPLETED';
export const VIDEO_PROGRESS = 'VIDEO_PROGRESS';
export const VIDEO_ERROR = 'VIDEO_ERROR';

export const initiateVideo = (actionIdentifier, actionInitated, engaged) => dispatch => {
    if (!actionInitated) {
        dispatch({
            type: VIDEO_INITIATED,
            payload: actionIdentifier
        });
    }
    if (!engaged) {
        dispatch({
            type: WIDGET_ENGAGED
        });
    }
};

export const playVideo = () => dispatch => dispatch({ type: VIDEO_PLAY });

export const pauseVideo = () => dispatch => dispatch({ type: VIDEO_PAUSED });

export const videoProgress = amount => dispatch =>
    dispatch({ type: VIDEO_PROGRESS, payload: amount });

export const videoCompleted = (
    apiRequestData,
    actionCompletedTime,
    actionIdentifier,
    actionCompleted
) => dispatch => {
    if (!actionCompleted) {
        dispatch({
            type: VIDEO_COMPLETED,
            payload: actionIdentifier
        });
        apiCompleteVideo(apiRequestData, actionCompletedTime);
    }
};
